import { render, staticRenderFns } from "./CompItemQuickView.vue?vue&type=template&id=124ad308"
import script from "./CompItemQuickView.vue?vue&type=script&lang=js"
export * from "./CompItemQuickView.vue?vue&type=script&lang=js"
import style0 from "./CompItemQuickView.vue?vue&type=style&index=0&id=124ad308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports